<mat-toolbar color="warn" class="flex justify-center h-8 "> <!-- justify-between -->
  <div>
    <span>[{{stateName}}]</span>
  </div>
  @if(isDialog()){
  <div><span>{{label()}}</span></div>
  }
  <div>
    @if(user1Visible()){
    <button class="btn" [class.btn-primary]="true" (click)="doUser1($event)">
      {{user1Text()}}
    </button>
    }
    @if(user2Visible()){
    <button class="btn" [class.btn-primary]="true" (click)="doUser2($event)">
      {{user2Text()}}
    </button>
    }
  </div>
  @if(isDialog()){
  <table class="w-32">
    <tr>
      <td>
        <button class="btn" [class.btn-primary]="true" cdkFocusInitial (click)="doOk($event)">
          <!-- 🆗  --><mat-icon fontIcon="done"></mat-icon>確定
        </button>
      </td>
      @if(cancelVisible()){
      <td>
        <button class="btn" [class.btn-warning]="true" (click)="doCancel($event)">
          <!--  ❌ --><mat-icon fontIcon="cancel"></mat-icon>取消
        </button>
      </td>
      }
    </tr>
  </table>
  }
</mat-toolbar>